export const openPositionDurationValues = [
  { id: 1, key: 'WEEKS', label: 'semaines' },
  { id: 2, key: 'MONTHS', label: 'mois' },
  { id: 3, key: 'YEARS', label: 'années' },
];
